import { LRUMap } from 'lru_map';
import { buildLRUCache } from '../lib/cache/LRUCache';
import { SiteClassification } from '../types/api/types';
import { getClassificationsStore } from './stores';

const classificationLRU = buildLRUCache<string, SiteClassification>(100);
type ClassificationLRU = LRUMap<string, SiteClassification>;

export const updateCache = (lru: ClassificationLRU) => {
  getClassificationsStore().set({ classifications: lru.toJSON() });
};

export const loadLRUFromCache = () => {
  const data = getClassificationsStore().get();
  if (!data) {
    return;
  }

  classificationLRU.init(data.classifications);
};

export const getCachedClassification = (hostname: string) =>
  classificationLRU.get(hostname);

export const setCachedClassification = (
  hostname: string,
  value: SiteClassification
) => classificationLRU.set(hostname, value, updateCache);

export const clearCachedClassification = () =>
  classificationLRU.clear(updateCache);
